import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AppFrame from "../../Appframe/AppFrame";
import layout from "../../../styles/layout";

import { Paper, Button } from "@material-ui/core";

import colors, { colorsV2 } from "../../../styles/colors";
import Title from "../../../components/common/Title";

const ChannelReports = (props) => {
  return (
    <AppFrame
      auth={props.auth}
      header="Channel Reporting"
      optionsType="organizationReporting"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <Title text1="" text2="" goBack={() => props.history.goBack()} />
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>Patient/Client Activity Log</h1>
        <p></p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/reports/channel/patient-client-activity-log`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>Client Satisfaction Survey (CSAT)</h1>
        <p></p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/reports/channel/csat-report`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>{" "}
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>Net Promoter Score (NPS)</h1>
        <p></p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/reports/channel/nps-report`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>RTM Billing</h1>
        <p></p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/reports/channel/rtm-billing`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>
    </AppFrame>
  );
};

function mapStateToProps({ user, organization, whiteLabelSettings }, props) {
  return { user, organization, whiteLabelSettings, ...props };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, null)(ChannelReports);



// WEBPACK FOOTER //
// ./src/layout/reporting/ChannelLevel/ChannelReports.js